// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* POWERED BY */
.Wk4nI64HY74brgbqdkvD {
  position: relative;
  width: 100%;
  box-shadow: 0px -6px 0px 0px rgb(188, 16, 56);
  -webkit-box-shadow: 0px -6px 0px 0px rgb(188, 16, 56);
  -moz-box-shadow: 0px -6px 0px 0px rgba(188, 16, 56, 1);
  touch-action: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background: #ffffff;
  z-index: 2;
}

.LHcx19IgsQuIn6BcRL2q {
  background: #bc1038;
  border-radius: 0.5rem 0.5rem 0 0;
  padding: 0.625rem 0;
  width: fit-content;
  position: absolute;
  bottom: 100%;
  transform: translateX(-50%);
  left: 50%;
  overflow: hidden;
}

.tRqdBOdu0koGF4Hrr9qb {
  all: unset;
  cursor: pointer;
  transition: filter var(--hover-transition-duration) ease-in-out;
}

.tRqdBOdu0koGF4Hrr9qb,
.N4nEPoNisZib0M0pIfHz {
  display: block;
  width: 100%;
  padding: 0.25rem 1rem 0 1rem;
}

.tRqdBOdu0koGF4Hrr9qb:hover {
  filter: brightness(0.95);
}

.tRqdBOdu0koGF4Hrr9qb:focus-visible {
  outline: var(--focus-outline);
  outline-offset: 4px;
}

#gw-map .O9OEqSuJvC84e7h2mm45 {
  margin: 0;
  line-height: 0;
  font-size: var(--map-sub-body-font-size);
  font-weight: 700;
  color: #ffffff;
  text-wrap: nowrap;
  transform: translateY(-0.25rem);
}

.X35_zVtYJ0c7v8En8Y2A {
  overflow: hidden;
  margin: 0 0.5vw;
  max-height: 1000px;
  opacity: 1;
  transform: translateY(0);
  transition: max-height 320ms ease, transform 320ms ease, opacity 200ms ease;
  will-change: max-height, transform, opacity;
}

.s_JrwrZ5IZTunIHp368t {
  max-height: 0;
  opacity: 0;
  transform: translateY(24px);
  pointer-events: none;
}

.AESrbmRrrSWmul0Uew7u {
  background: #ffffff;
  padding-top: 0;
}

.Mm0HTmNKtGRBd60Qk6Dm {
  list-style: none;
  margin: 0;
  padding: 0;
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(12.5px, 12.825vw));
  place-content: space-evenly;
  place-items: center;
}

.ZvaEkn5AJZlZlRiSLEVp {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-width: 0;
}

.QmiFqYxCPFvduxIZjOb6 {
  display: flex;
  width: 100%;
  height: 100%;
  padding: 0.5rem;
  align-items: center;
  justify-content: center;
}

.zZ38aNtH1HhcqSliVOe8 {
  display: block;
  max-width: 100%;
  height: auto;
  width: 100%;
  object-fit: contain;
}

#gw-map .Wk4nI64HY74brgbqdkvD img {
  max-width: 100%;
}`, "",{"version":3,"sources":["webpack://./../core/components/sponsors/Sponsors.module.css"],"names":[],"mappings":"AAAA,eAAe;AACf;EACE,kBAAkB;EAClB,WAAW;EACX,6CAA6C;EAC7C,qDAAqD;EACrD,sDAAsD;EACtD,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,2BAA2B;EAC3B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,+DAA+D;AACjE;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,wCAAwC;EACxC,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,wBAAwB;EACxB,2EAA2E;EAC3E,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,UAAU;EACV,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,WAAW;EACX,aAAa;EACb,iEAAiE;EACjE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB","sourcesContent":["/* POWERED BY */\r\n.poweredByContainer {\r\n  position: relative;\r\n  width: 100%;\r\n  box-shadow: 0px -6px 0px 0px rgb(188, 16, 56);\r\n  -webkit-box-shadow: 0px -6px 0px 0px rgb(188, 16, 56);\r\n  -moz-box-shadow: 0px -6px 0px 0px rgba(188, 16, 56, 1);\r\n  touch-action: none;\r\n  -webkit-user-select: none;\r\n  -moz-user-select: none;\r\n  -ms-user-select: none;\r\n  user-select: none;\r\n  background: #ffffff;\r\n  z-index: 2;\r\n}\r\n\r\n.poweredByHeading {\r\n  background: #bc1038;\r\n  border-radius: 0.5rem 0.5rem 0 0;\r\n  padding: 0.625rem 0;\r\n  width: fit-content;\r\n  position: absolute;\r\n  bottom: 100%;\r\n  transform: translateX(-50%);\r\n  left: 50%;\r\n  overflow: hidden;\r\n}\r\n\r\n.poweredByHeadingButton {\r\n  all: unset;\r\n  cursor: pointer;\r\n  transition: filter var(--hover-transition-duration) ease-in-out;\r\n}\r\n\r\n.poweredByHeadingButton,\r\n.poweredByHeadingStatic {\r\n  display: block;\r\n  width: 100%;\r\n  padding: 0.25rem 1rem 0 1rem;\r\n}\r\n\r\n.poweredByHeadingButton:hover {\r\n  filter: brightness(0.95);\r\n}\r\n\r\n.poweredByHeadingButton:focus-visible {\r\n  outline: var(--focus-outline);\r\n  outline-offset: 4px;\r\n}\r\n\r\n:global(#gw-map) .poweredByHeadingText {\r\n  margin: 0;\r\n  line-height: 0;\r\n  font-size: var(--map-sub-body-font-size);\r\n  font-weight: 700;\r\n  color: #ffffff;\r\n  text-wrap: nowrap;\r\n  transform: translateY(-0.25rem);\r\n}\r\n\r\n.poweredByContainerInner {\r\n  overflow: hidden;\r\n  margin: 0 0.5vw;\r\n  max-height: 1000px;\r\n  opacity: 1;\r\n  transform: translateY(0);\r\n  transition: max-height 320ms ease, transform 320ms ease, opacity 200ms ease;\r\n  will-change: max-height, transform, opacity;\r\n}\r\n\r\n.collapsed {\r\n  max-height: 0;\r\n  opacity: 0;\r\n  transform: translateY(24px);\r\n  pointer-events: none;\r\n}\r\n\r\n.poweredBySponsors {\r\n  background: #ffffff;\r\n  padding-top: 0;\r\n}\r\n\r\n.poweredBySponsorsContainer {\r\n  list-style: none;\r\n  margin: 0;\r\n  padding: 0;\r\n  width: 100%;\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(12.5px, 12.825vw));\r\n  place-content: space-evenly;\r\n  place-items: center;\r\n}\r\n\r\n.poweredByLogoContainer {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 100%;\r\n  min-width: 0;\r\n}\r\n\r\n.poweredByLogo {\r\n  display: flex;\r\n  width: 100%;\r\n  height: 100%;\r\n  padding: 0.5rem;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.sponsorLogo {\r\n  display: block;\r\n  max-width: 100%;\r\n  height: auto;\r\n  width: 100%;\r\n  object-fit: contain;\r\n}\r\n\r\n:global(#gw-map) .poweredByContainer img {\r\n  max-width: 100%;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"poweredByContainer": `Wk4nI64HY74brgbqdkvD`,
	"poweredByHeading": `LHcx19IgsQuIn6BcRL2q`,
	"poweredByHeadingButton": `tRqdBOdu0koGF4Hrr9qb`,
	"poweredByHeadingStatic": `N4nEPoNisZib0M0pIfHz`,
	"poweredByHeadingText": `O9OEqSuJvC84e7h2mm45`,
	"poweredByContainerInner": `X35_zVtYJ0c7v8En8Y2A`,
	"collapsed": `s_JrwrZ5IZTunIHp368t`,
	"poweredBySponsors": `AESrbmRrrSWmul0Uew7u`,
	"poweredBySponsorsContainer": `Mm0HTmNKtGRBd60Qk6Dm`,
	"poweredByLogoContainer": `ZvaEkn5AJZlZlRiSLEVp`,
	"poweredByLogo": `QmiFqYxCPFvduxIZjOb6`,
	"sponsorLogo": `zZ38aNtH1HhcqSliVOe8`
};
module.exports = ___CSS_LOADER_EXPORT___;
